export enum PiSuggestedTopicsCategories {
  communication = 'Communication',
  day_to_day_work = 'Day-to-Day Work',
  relationship_building = 'Relationship Building',
}

export enum PiSuggestedTopicType {
  general = 'general',
  factor = 'factor',
  factorCombination = 'factorCombination',
}

interface BasePiSuggestedTopic {
  category: PiSuggestedTopicsCategories;
  suggestion: string;
}

export interface GeneralPiSuggestedTopic extends BasePiSuggestedTopic {
  type: PiSuggestedTopicType.general;
}

type Factor = 'A' | 'B' | 'C' | 'D';
type SigmaZonePlacement = 'low' | 'high' | 'situational';

export interface FactorPiSuggestedTopic extends BasePiSuggestedTopic {
  type: PiSuggestedTopicType.factor;
  factor: Factor;
  sigmaZonePlacement: SigmaZonePlacement;
  basedOn: string;
}

type FactorCombination =
  | 'A over B'
  | 'A over C'
  | 'A over D'
  | 'B over A'
  | 'B over C'
  | 'B over D'
  | 'C over A'
  | 'C over B'
  | 'C over D'
  | 'D over A'
  | 'D over B'
  | 'D over C';

export interface FactorCombinationPiSuggestedTopic extends BasePiSuggestedTopic {
  type: PiSuggestedTopicType.factorCombination;
  combination: FactorCombination;
  basedOn: string;
}

export type PiSuggestedTopic = GeneralPiSuggestedTopic | FactorPiSuggestedTopic | FactorCombinationPiSuggestedTopic;
